export default {
    accountStepTitle: "Compte",
    accountStepActionLabel: "Suivant",

    paymentStepTitle: "Paiement",
    ikeepayPaymentMethodTitle: "Paiement sécurisé avec Ikeepay",
    ikeepayPaymentMethodDescription: "Mobile Money ou carte, au choix dans la fenêtre suivante",
    ikeepayCheckoutErrorMessage: "La fenêtre de paiement n'a pas pu s'ouvrir. Veuillez réessayer.",

    confirmStepTitle: "Confirmation",
    confirmStepActionLabel: "Confirmer",
    confirmStepSubTitle: "Vérification de la commande",
    confirmStepDescription: "Vérifiez les informations avant de finaliser votre paiement.",
    confirmAndPayStepActionLabel: "Payer {{localizedAmount}}",

    editStepDetailActionLabel: "Modifier",

    subscriptionPlanCardTitle: "Récapitulatif de la commande",
    subscriptionPlanCardDescription: "Sélectionnez une offre",
    subscriptionPlanCardTotalLabel: "Total",

    checkoutPagePlatformDisclaimer: "Cette plateforme est destinée à la préparation aux examens de langue et n'est affiliée à aucun organisme officiel d'évaluation.",
    confirmCheckoutInfoNotice: "En confirmant, vous acceptez nos <terms> Conditions d’utilisation</terms>",
    confirmCheckoutInfoAndPayNotice:"En confirmant, vous acceptez nos <terms> Conditions d’utilisation</terms> et autorisez un paiement de <bold>{{localizedPrice}}</bold> via Ikeepay. Une fenêtre de paiement sécurisée s'ouvrira pour le finaliser.",

    nextCheckoutStepActionLabel: "Suivant",
    previousCheckoutStepActionLabel: "Précédent",
}